import { useMutation } from '@tanstack/react-query';

import type { OverrideAccountRiskRatingPayload } from 'api/RiskAssessmentsApi';
import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { ACCOUNT_RISK_PROFILE_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useOverrideAccountRiskRating() {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();
  const { setAccountRiskProfile } = useFiRiskAssessmentCache();

  const { mutateAsync: overrideAccountRiskRating, isPending: isOverridingAccountRiskRating } = useMutation({
    mutationKey: [ACCOUNT_RISK_PROFILE_KEY, 'override'],
    mutationFn: ({ dispensaryId, ...data }: OverrideAccountRiskRatingPayload & { dispensaryId: string }) =>
      riskAssessmentsApi.overrideAccountRiskRating(userBankId, dispensaryId, data),
    onSuccess: (profile, { dispensaryId }) => {
      setAccountRiskProfile(dispensaryId, profile);
    },
    meta: {
      snackbarSuccessMessage: 'Risk rating overridden.',
      snackbarErrorMessage: 'There was an issue overriding the risk rating. Please contact support.'
    }
  });

  return { overrideAccountRiskRating, isOverridingAccountRiskRating };
}
